/* Jardim Brasil — dispara a pincelada quando a palavra aparece na tela. */
(function () {
  var SEL = '.jb-mark, .jb-neuro__mark, .jbb__mark, .jbc__mark, .jbk__mark, .jbp__mark, .jbs__mark, .jbf__mark';
  function liga(raiz) {
    var marcas = (raiz || document).querySelectorAll(SEL);
    if (!marcas.length) return;
    if (!('IntersectionObserver' in window)) {
      marcas.forEach(function (m) { m.classList.add('jb-aq'); });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var atraso = Number(el.getAttribute('data-jb-aq-atraso') || 0);
        setTimeout(function () { el.classList.add('jb-aq'); }, atraso);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.25 });
    marcas.forEach(function (m) { if (!m.classList.contains('jb-aq')) io.observe(m); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { liga(); });
  else liga();
  document.addEventListener('shopify:section:load', function (e) { liga(e.target || document); });
})();
